export interface IRecurringTaskSlot {
  weekDay: number;
  startMinute: number;
}

export interface IRecurringTask {
  organization: string;
  _id: string;
  label: string;
  slots: IRecurringTaskSlot[];
  startDate: Date;
  /** in minuets, this will override service duration */
  slotDuration?: number;
  endDate: Date;
  template?: {
    type: string;
    description: string;
    notes: string;
    tags?: string[];
  };
  meta?: any;
  createdAt?: Date;
  updatedAt?: Date;
}

export type RecurringTaskStatus = 'active' | 'disabled';

import { IsNotEmpty, IsString, IsOptional, IsDate } from 'class-validator';
import { IBaseResponse } from './base-response.dto';

/* -------------------------------------------------------------------------- */
/*                               Create new RecurringTask                              */
/* -------------------------------------------------------------------------- */

export class CreateRecurringTaskDto {
  @IsNotEmpty()
  @IsString()
  label: string;

  @IsOptional()
  slots: IRecurringTaskSlot[] = [];

  @IsOptional()
  startDate: Date;

  @IsOptional()
  endDate: Date;

  template: any;
}

export interface CreateRecurringTaskResponse extends IBaseResponse {
  recurringTask: IRecurringTask;
}

/* -------------------------------------------------------------------------- */
/*                                   Update RecurringTask                              */
/* -------------------------------------------------------------------------- */

export class UpdateRecurringTaskDto {
  @IsNotEmpty()
  @IsString()
  status: RecurringTaskStatus;

  @IsNotEmpty()
  @IsString()
  label: string;

  @IsOptional()
  @IsString()
  description: string;

  @IsOptional()
  slots: IRecurringTaskSlot[] = [];

  @IsOptional()
  @IsDate()
  startDate: Date;

  @IsOptional()
  @IsDate()
  endDate: Date;

  slotDuration?: number;
}

export interface UpdateRecurringTaskResponse extends IBaseResponse {
  recurringTask: IRecurringTask;
}

/* -------------------------------------------------------------------------- */
/*                                   Add RecurringTask Slot                          */
/* -------------------------------------------------------------------------- */

export class AddRecurringTaskSlotDto {
  @IsNotEmpty()
  @IsDate()
  startDate: Date;

  @IsNotEmpty()
  @IsDate()
  endDate: Date;
}

export interface GetRecurringTaskResponse extends IBaseResponse {
  recurringTask: IRecurringTask;
}

/* -------------------------------------------------------------------------- */
/*                                  Get RecurringTasks                                 */
/* -------------------------------------------------------------------------- */
export class GetRecurringTasksDto {
  label?: string;
}

export type GetRecurringTasksResponse = IRecurringTask[];
